import { up } from "styled-breakpoints";
import styled from "styled-components";
import { ReactComponent as QuoteOpen } from "../../assets/svg/quote-open.svg";
import { Box } from "../Box";
import { Text } from "../Text";

interface IntroQuoteProps {}

const Wrapper = styled.div`
  position: relative;
`;

const QuoteOpenBox = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;

  svg {
    width: 100%;
    height: 100%;
  }
`;

const QuoteCloseBox = styled(Box)`
  position: absolute;
  bottom: 32px;
  right: 0;

  svg {
    width: 100%;
    height: 100%;
  }
`;

const TextBox = styled(Box)`
  text-align: left;
  padding-top: 10px;
  text-indent: 64px;

  p::after {
    content: "endquote";
    opacity: 0;
    visibility: hidden;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    text-indent: 80px;
    padding-top: 14px;
  }
  ${({ theme }) => theme.mediaQueries.lg} {
    text-indent: 96px;
    padding-top: 16px;
  }
`;

const NameBox = styled(Box)`
  text-align: left;
  margin-top: 16px;
`;

const quoteSize = [48, 64, null, null, 80];

export const IntroQuote: React.FC<IntroQuoteProps> = ({}) => {
  return (
    <Wrapper>
      <QuoteOpenBox width={quoteSize} height={quoteSize} color="hotPink">
        <QuoteOpen />
      </QuoteOpenBox>
      <TextBox color="white">
        <Text textAlign="left" variant="h4" fontWeight={700} as="p">
          …our branches…. remained open until midnight. Long queues of people
          waited with prescriptions. Everywhere our assistants rendered both the
          public and the firm a most devoted service, and did so regardless of
          their own comfort or even of their own health.
        </Text>
      </TextBox>
      <NameBox color="white">
        <Text variant="h5" fontWeight={700} as="span">
          Jesse Boot, 1919
        </Text>
      </NameBox>

      <QuoteCloseBox width={quoteSize} height={quoteSize} color="hotPink">
        <QuoteOpen />
      </QuoteCloseBox>
    </Wrapper>
  );
};
